import React from "react";
import { withMyDataContext } from "../../context/DataProvider";
import Aux from "../AuxFunctions";
import Colors from "../Colors"
import Fire from "../../config/Fire";
import moment from "moment";
import { Link } from 'react-router-dom'

import ButtonLoader from "../Utilities/ButtonLoader";
import CongratulationsModal from "../Utilities/CongratulationsModal";

class SingleNotification extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            user: {},
            isPending: false,
            isModalVisible: false,
            claimLoading: false,
            openModal: false,
            loadingAccept: false,
            loadingRefuse: false,
            acceptRequest: false,
        }

        this.renderLike = this.renderLike.bind(this)
        this.renderComment = this.renderComment.bind(this)
        this.renderMessage = this.renderMessage.bind(this)
        this.renderReferralReward = this.renderReferralReward.bind(this)
        this.renderRequest = this.renderRequest.bind(this)
        this.renderSystemMessage = this.renderSystemMessage.bind(this)
        this.ChooseTypeNotification = this.ChooseTypeNotification.bind(this)
    }

    componentDidMount() {
        try {
            this.setState({ isPending: this.props.notification.state === "pending", acceptRequest: this.props.notification.state === "accepted" })
            this.getUserInfo();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserInfo = async () => {
        try {
            var uid = this.props.notification.uid
            if(this.props.notification.type === "request_message" || this.props.notification.type === "request" || this.props.notification.type === "accepted_request"){
                uid = this.props.notification.requestSentBy
            }
            let userQuery = await Fire.shared.firestore.collection("users").doc(uid).get();
            if (userQuery.exists) {
                this.setState({ user: userQuery.data() })
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getTime = () => {
        if(!this.props.notification.timestamp)
        return null
        
        return moment(this.props.notification.timestamp.toDate()).fromNow();
    }

    getUsername = () => {
        return (this.state.user.username || "Unknown").toString()
    }

    RenderPostImage = () => {
        if (this.props.notification.image)
            return (
                <img style={{ height: 45, width: 45, borderRadius: 4, alignSelf: "center" }} alt="Post thumbnail"
                    src={this.props.notification.image}>
                </img>
            )
        else if (this.props.notification.text) {
            return (
                <div style={{ display: "flex", height: 45, width: 45, borderRadius: 4, backgroundColor: "#f9f9f9", justifyContent: "center" }}>
                    <span style={{ alignSelf: "center", color: "#ccc" }}>
                        {this.props.notification.text.substring(0, 5)}
                    </span>
                </div>
            )
        } else {
            return null;
        }
    }

    

    claimReward = async () => {
        try {
            this.setState({ claimLoading: true })
            await Fire.shared.acceptPending(
                this.props.notification.id,
                this.props.notification.type,
                this.props.notification.coins,
                this.props.notification.uid).then((accepted) => {
                    if (accepted) {
                        // this.props.myDataProvider.addCoins(this.props.notification.coins)
                        this.setState({ openModal: true, claimLoading: false, isPending: false });
                    } else {
                        this.setState({ claimLoading: false });
                    }

                })
        } catch (error) {
            this.setState({ claimLoading: false })
            Aux.handleError(error)
        }
    }

    acceptRequest = async() => {
        try{
            this.setState({loadingAccept: true})
            const result = await Fire.shared.acceptRequestAndCreateChat(this.props.notification.id, this.props.notification.requestSentBy, this.props.notification.text, this.props.notification.coins)
            if(result){
                this.setState({isPending:false, acceptRequest: true, openModal:this.props.notification.coins? true : false})
            }
            this.setState({loadingAccept: false})
        }catch(error){
            Aux.handleError(error)
            this.setState({loadingAccept: false})
        }
    }

    refuseRequest = async() => {
        try{
            this.setState({loadingRefuse: true})
            const result = await Fire.shared.refuseRequest(this.props.notification.id)
            if(result){
                this.setState({isPending:false, acceptRequest: false})
            }
            this.setState({loadingRefuse: false})
        }catch(error){
            Aux.handleError(error)
            this.setState({loadingRefuse: false})
        }
    }

    ChooseTypeNotification() {
        switch (this.props.notification.type) {
            case "like":
                return <this.renderLike />
            case "comment":
                return <this.renderComment />
            case "message":
                return <this.renderMessage />
            case "request_message":
                return <this.renderRequestMessage/>
            case "request":
                return <this.renderRequest/>
            case "accepted_request":
                return <this.renderAcceptedRequest/>
            case "referral_used":
                return <this.renderReferralReward />
            case "referral_reward":
                return <this.renderReferralReward />
            case "system_message":
                return <this.renderSystemMessage />
            default:
                return null;
        }
    }

    renderLike() {
        return (

            <div className="notification-container" style={{ display: "flex", justifyContent: "space-between" }}>
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                        {Aux.showAvatar(45, this.state.user.avatar, this.state.user.username || "Unknown")}
                    </Link>
                    <div style={{ margin: "0 20px" }}>

                        <div >
                            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere"}}
                                    /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                            </Link>
                            {this.props.notification.likesCount > 1 ?
                                <span>
                                    {" "}and {this.props.notification.likesCount} other liked your post
                                </span>
                                :
                                <span>
                                    {" "}liked your post
                                </span>
                            }

                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>

                </div>
                <this.RenderPostImage></this.RenderPostImage>
                {/* </View> */}
            </div>
        );
    }

    renderComment() {
        return (
            <div className="notification-container">
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }} >
                        {Aux.showAvatar(45, this.state.user.avatar, this.state.user.username || "Unknown")}
                    </Link>
                    <div style={{ margin: "0 20px" }}>

                        <div >
                            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100 , overflowWrap:"anywhere"}}
                                    /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                            </Link>
                            <span>
                                {" "}commented on your post
                            </span>
                            <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 15, color: "lightgrey" }}>
                                <p />"{this.props.notification.commentText}"
                            </span>
                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>
                    <this.RenderPostImage></this.RenderPostImage>
                </div>
                {this.state.isPending ?
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <ButtonLoader
                            text={"Claim " + this.props.notification.coins + "$"}
                            loading={this.state.claimLoading}
                            style={{ backgroundColor: Colors.mainColor, width: "70%", padding: "12px 20px" }}
                            // icon={FacebookIcon}
                            onClick={this.claimReward}
                        ></ButtonLoader>
                    </div>
                    : null}
            </div>
        );
    }

    renderRequestMessage =() => {
        return (
            <div className="notification-container">
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", marginRight:20 }}>
                        {Aux.showAvatar(45, this.state.user.avatar,  this.state.user.username || "Unknown")}
                    </Link>
                    <div >
                        <div >
                            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}
                                /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                            </Link>
                            <span>
                                {" "}sent you a message request:
                        </span>
                            <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 15, color: Colors.mainColor }}>
                                <p />{this.props.notification.text}
                            </span>
                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>
                </div>
                {this.state.isPending ?
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <ButtonLoader
                            text={"Accept " + this.props.notification.coins + "$"}
                            loading={this.state.loadingAccept}
                            style={{ backgroundColor: Colors.mainColor, padding: "12px 20px" }}
                            // icon={FacebookIcon}
                            onClick={this.acceptRequest}
                        ></ButtonLoader>
                        <ButtonLoader
                            text={"Refuse"}
                            loading={this.state.loadingRefuse}
                            style={{ backgroundColor: Colors.red, padding: "12px 20px", marginLeft:30}}
                            // icon={FacebookIcon}
                            onClick={this.refuseRequest}
                        ></ButtonLoader>
                    </div>
                    : null}
            </div>
        );
    }

    renderRequest = () => {
        return (
            <div className="notification-container">
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", marginRight:20 }}>
                        {Aux.showAvatar(45, this.state.user.avatar,  this.state.user.username || "Unknown")}
                    </Link>
                    <div >
                        <div >
                            {!this.state.isPending && this.state.acceptRequest ? 
                            <span>
                                You've accepted{" "} 
                            </span> : 
                            !this.state.isPending && !this.state.acceptRequest ?
                            <span> You've refused{" "} </span> : null}
                            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}
                                /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                            </Link>
                            {this.state.isPending ? 
                            <span>
                                {" "}sent you a request
                            </span> : <span> {" "} request</span>}
                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>
                </div>
                {this.state.isPending ?
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <ButtonLoader
                            text={"Accept"}
                            loading={this.state.loadingAccept}
                            style={{ backgroundColor: Colors.mainColor, padding: "12px 20px" }}
                            // icon={FacebookIcon}
                            onClick={this.acceptRequest}
                        ></ButtonLoader>
                        <ButtonLoader
                            text={"Refuse"}
                            loading={this.state.loadingRefuse}
                            style={{ backgroundColor: Colors.red, padding: "12px 20px", marginLeft:30 }}
                            // icon={FacebookIcon}
                            onClick={this.refuseRequest}
                        ></ButtonLoader>
                    </div>
                    : null}
            </div>
        );
    }

    renderAcceptedRequest = () => {
        return (
            <div className="notification-container">
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", marginRight:20}} >
                        {Aux.showAvatar(45, this.state.user.avatar,  this.state.user.username || "Unknown")}
                    </Link>
                    <div >
                        <div>
                            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}
                                /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                            </Link>
                            <span> {" "}accepted your request</span>
                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    renderMessage() {
        return (
            <div className="notification-container">
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", marginRight:20 }} >
                        {Aux.showAvatar(45, this.state.user.avatar,  this.state.user.username || "Unknown")}
                    </Link>
                    <div >
                        <div >
                            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", }}>
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}
                                /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                            </Link>
                            <span>
                                {" "}sent you a message
                        </span>
                            <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 15, color: "lightgrey" }}>
                                <p />"{this.props.notification.text}"
                                </span>
                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>
                    {/* <this.RenderPostImage></this.RenderPostImage> */}
                </div>
                {this.state.isPending ?
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <ButtonLoader
                            text={"Claim " + this.props.notification.coins + "$"}
                            loading={this.state.claimLoading}
                            style={{ backgroundColor: Colors.mainColor, width: "70%", padding: "12px 20px" }}
                            // icon={FacebookIcon}
                            onClick={this.claimReward}
                        ></ButtonLoader>
                    </div>
                    : null}
            </div>
        );
    }

    renderSystemMessage() {
        return (
            <div className="notification-container">
                {/* <View style={{}}> */}
                <div style={{ display: "flex", flexDirection: "row", }}>
                    <img style={{ height: 45, width: 45, borderRadius: 25, alignSelf: "flex-start", objectFit: "contain", marginRight:20 }}
                        src={Aux.LogoImage} alt="logo">
                    </img>
                    <div >
                        <div >
                            <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}>
                                {this.props.notification.text}
                            </span>
                            {/* <span>
                                    {" "}sent you a message
                                </span>
                                <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 15, color: "lightgrey" }}>
                                    <p />"{this.props.notification.text}"
                                </span> */}
                        </div>
                        <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                            {this.getTime()}
                        </span>
                    </div>
                    {/* <this.RenderPostImage></this.RenderPostImage> */}
                </div>
                {this.state.isPending ?
                    /* <div style={{
                        marginTop: 10, borderRadius: 5, backgroundColor: Colors.mainColor, marginLeft: 60,
                        justifyContent: "center", alignItems: "center", alignSelf: "flex-start", height: 40, paddingHorizontal: 70
                    }}
                        >
                        <span style={{ alignSelf: "center", fontSize: 16, color: "white" }}>Claim {this.props.notification.coins}$</span>
                    </div> */
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <ButtonLoader
                            text={"Claim " + this.props.notification.coins + "$"}
                            loading={this.state.claimLoading}
                            style={{ backgroundColor: Colors.mainColor, width: "70%", padding: "12px 20px" }}
                            // icon={FacebookIcon}
                            onClick={this.claimReward}
                        ></ButtonLoader>
                    </div>
                    : null}

            </div>
        );
    }

    renderReferralReward = () => {
        return (
            <div className="notification-container">
                <div style={{ display: "flex", flexDirection: "row",  }}>
                    <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none", marginRight:20}} >
                        {Aux.showAvatar(45, this.state.user.avatar,  this.state.user.username || "Unknown")}
                    </Link>
                    <div >
                        <div>
                            <span>
                                {this.props.notification.type === "referral_used" ?
                                    null
                                    :
                                    <span>
                                        You have used{" "}
                                    </span>
                                }
                                <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}
                                    /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                    {this.getUsername().length < 25
                                        ? this.getUsername()
                                        : this.getUsername().substring(0, 25) + "..."}
                                </span>
                                {this.props.notification.type === "referral_used" ?
                                    <span>
                                        {" "}used your refer link
                                </span>
                                    :
                                    <span>
                                        {" "}referral link
                                </span>
                                }
                            </span>
                            <div>
                                <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText }}>
                                    {this.getTime()}
                                </span>
                            </div>
                        </div>

                    </div>

                    {/* <this.RenderPostImage></this.RenderPostImage> */}
                </div>
                {this.state.isPending ?
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <ButtonLoader
                            text={"Claim " + this.props.notification.coins + "$"}
                            loading={this.state.claimLoading}
                            style={{ backgroundColor: Colors.mainColor, width: "70%", padding: "12px 20px" }}
                            // icon={FacebookIcon}
                            onClick={this.claimReward}
                        ></ButtonLoader>
                    </div>
                    : null}
            </div>
        );
    }

    /* RenderPostImage = (image, text) => {
        console.log("RENDER IMAGE")
        console.log(this.props.notification.image)
        if (image)
            return (
                <div>
                <img style={{ height: 45, width: 45, borderRadius: 4, alignSelf: "center" }}
                    src={image} alt="Image">
                </img>
                </div>
            )
        else if (text) {
            return (
                <div style={{ height: 45, width: 45, borderRadius: 4, backgroundColor: "#f9f9f9", justifyContent: "center" }}>
                    <span style={{ alignSelf: "center", color: "#ccc" }}>
                        {text.substring(0, 5)}
                    </span>
                </div>
            )
        } else {
            return null;
        }
    } */

    toggleModal = () => {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    render() {
        return (
            <div>
                <CongratulationsModal active={this.state.openModal} onClose={this.toggleModal} coins={this.props.notification.coins}></CongratulationsModal>
                <this.ChooseTypeNotification />
            </div>
        )
    }
}

export default withMyDataContext(SingleNotification)

